/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Video_Upload_PdfsInputs */

const en_mobile_video_upload_pdfs = /** @type {(inputs: Mobile_Video_Upload_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video: Upload PDFs`)
};

const es_mobile_video_upload_pdfs = /** @type {(inputs: Mobile_Video_Upload_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video: subir PDF`)
};

/**
* | output |
* | --- |
* | "Video: Upload PDFs" |
*
* @param {Mobile_Video_Upload_PdfsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_video_upload_pdfs = /** @type {((inputs?: Mobile_Video_Upload_PdfsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Video_Upload_PdfsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_video_upload_pdfs(inputs)
	return en_mobile_video_upload_pdfs(inputs)
});